//#region src/bootRecovery.ts
var e = "maat.bootRecovery";
function t() {
	if (!(typeof window > "u")) try {
		return window.sessionStorage;
	} catch {
		return;
	}
}
function n() {
	if (typeof document > "u") return;
	let e = document.querySelector("meta[name=\"build-number\"]")?.getAttribute("content");
	return e && !e.startsWith("__") ? e : void 0;
}
function r(r, i) {
	let a = {
		reason: r,
		detail: i,
		build: n(),
		at: Date.now()
	};
	try {
		t()?.setItem(e, JSON.stringify(a));
	} catch {}
}
function i() {
	let n = t();
	if (!n) return null;
	try {
		let t = n.getItem(e);
		if (!t) return null;
		n.removeItem(e);
		let r = JSON.parse(t);
		return typeof r.reason == "string" && typeof r.at == "number" ? r : null;
	} catch {
		return null;
	}
}
//#endregion
export { e as BOOT_RECOVERY_KEY, r as noteBootRecovery, i as takeBootRecovery };
